import { FastlyImage } from '@components/common/image'
import { useProfileContext } from '@contexts/profile'
import { PROFILE_IMAGE_PATH } from '@lib/constants/profile'
import React, { useMemo } from 'react'

type StatCardProps = {
  title: 'Classes completed' | 'Quizzes submitted' | 'Projects submitted'
  stat: number
}

const StatCard = ({ stat, title }: StatCardProps) => {
  const image = useMemo(() => {
    let imagePath = PROFILE_IMAGE_PATH
    switch (title) {
      case 'Classes completed':
        imagePath += 'completed-classes.png'
        break
      case 'Projects submitted':
        imagePath += 'submitted-projects.png'
        break
      case 'Quizzes submitted':
        imagePath += 'submitted-quizzes.png'
        break
      default:
        break
    }

    return imagePath
  }, [])

  return (
    <div className="flex bg-white text-grey font-600 rounded-lg p-5 items-center justify-center space-x-2 shadow-sm">
      <div>
        <FastlyImage src={image} width={55} height={55} />
      </div>
      <p className="w-20 leading-tight">{title}</p>
      <p className="text-xl">{stat}</p>
    </div>
  )
}

const StudentStats = () => {
  const { profileDetails } = useProfileContext()
  const stats = profileDetails?.performanceDetails
  return (
    <div className="grid gap-6 md:grid-cols-3">
      <StatCard stat={stats.classesCompleted} title="Classes completed" />
      <StatCard stat={stats.quizzesSubmitted} title="Quizzes submitted" />
      <StatCard stat={stats.projectsSubmitted} title="Projects submitted" />
    </div>
  )
}

export default React.memo(StudentStats)
